export default "__VITE_ASSET__B0ZhtU0S__"